export default [
  {
    name: 'Complexes',
    path: 'complexes',
    component: () => import('./components/complexes/List'),
    meta: { wide: true }
  },
  {
    name: 'Complexes.Edit',
    path: 'complexes/:id?/edit',
    props: true,
    component: () => import('./components/complexes/Edit')
  },
  {
    name: 'Complexes.Objects',
    path: 'complexes/:id/objects',
    props: true,
    component: () => import('./components/objects/List'),
    meta: { wide: true }
  },
  {
    name: 'Complexes.Objects.Edit',
    path: 'complexes/:id/objects/:objectId?/edit',
    props: true,
    component: () => import('./components/objects/Edit')
  },
  {
    name: 'Complexes.Objects.Sections',
    path: 'complexes/:id/objects/:objectId/sections',
    props: true,
    component: () => import('./components/sections/List')
  },
  {
    name: 'Complexes.Objects.Sections.Edit',
    path: 'complexes/:id/objects/:objectId/sections/:sectionId?/edit',
    props: true,
    component: () => import('./components/sections/Edit')
  },
  {
    name: 'Complexes.Objects.Sections.Floors.Edit',
    path:
      'complexes/:id/objects/:objectId/sections/:sectionId/floors/:floorId?/edit',
    props: true,
    component: () => import('./components/floors/Edit'),
    meta: { wide: true }
  },
  {
    name: 'Complexes.Objects.Bti',
    path:
      'complexes/:id/objects/:objectId/bti_layouts',
    props: true,
    component: () => import('./components/bti_layouts/List'),
    meta: { wide: true }
  },
  {
    name: 'Complexes.Layouts',
    path: 'layouts',
    component: () => import('./components/layouts/List')
  },
  {
    name: 'Complexes.Layouts.Edit',
    path: 'layouts/:layoutId?/edit',
    props: true,
    component: () => import('./components/layouts/Edit')
  },
  {
    name: 'Complexes.Advantages.List',
    path: 'advantages',
    component: () => import('./components/advantages/List')
  },
  {
    name: 'Complexes.Advantages.ObjectsList',
    path: 'advantages/:advantageId/assignments',
    props: true,
    component: () => import('./components/advantages/ObjectsList')
  },
  {
    name: 'Complexes.Advantages.Edit',
    path: 'advantages/:advantageId?/assignments/:id(\\d+)?/edit',
    props: true,
    component: () => import('./components/advantages/Edit')
  }
]
